import zionDebug from '@fs/zion-debug'
import { addAppAttribution, generateSls } from '@fs/zion-sls'
import { saveTaskEdits } from '../../shared/services/recordEnhancement/recordEnhancementService'
import { errorCollector } from '../../shared/utils/utils'

const debug = zionDebug('rip:saveUtils') // to turn this on do this in the console: localStorage.debug = 'fs:rip:saveUtils'

const saveSls = async ({
  dispatches,
  updateState = true,
  userId,
  taskTypeParam,
  appName,
  saveChangesFlag,
  zionSLSState,
  zionSlsDispatch,
  handleError = () => {},
  handleSuccess = () => {},
}) => {
  try {
    const sls = generateSls(dispatches)
    if (saveChangesFlag.isOn) {
      if (sls?.length) {
        addAppAttribution(sls, userId, appName)
        debug('saveSls: ', { sls })
        try {
          await saveTaskEdits(zionSLSState.currentImageArk, sls, false, false, taskTypeParam)
          if (updateState) {
            zionSlsDispatch({
              type: 'BATCH_DISPATCHES',
              value: dispatches,
            })
          }
          handleSuccess()
        } catch (error) {
          errorCollector(error, null, {
            codeId: 7777,
            sls,
            status: error?.response?.status,
            responseBody: error?.response?.data,
          })
          handleError(error)
        }
      } else {
        handleSuccess()
      }
    } else {
      handleSuccess()
      debug('Saving changes to SLS is disabled')
    }
  } catch (error) {
    errorCollector(error, null, {
      codeId: 7778,
      sls: error?.sls,
      dispatches: error?.dispatches,
    })
    handleError(error)
  }
}

export default saveSls
